import { useState } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import type {
  ChatRequestBody,
  MessageRequestBody,
} from '~/api/shopping-assistant/types'

/**
 * API client for the Shopping Assistant service.
 */
export function useShoppingAssistantApi() {
  const $httpFetch = useHttpFetch()

  const onRequest = ({
    options: { headers },
  }: {
    options: { headers: Headers }
  }) => {
    const forwardedAmplitudeDeviceId = useState<string | undefined>(
      'amplitude-device-id',
    ).value

    if (forwardedAmplitudeDeviceId) {
      headers.set('bm-amplitude-device-id', forwardedAmplitudeDeviceId)
    }
  }

  const startChat = async (chatId: string | null, body: ChatRequestBody) => {
    let responseStatus = 0

    const onResponse = ({ response }: { response: { status: number } }) => {
      responseStatus = response.status
    }

    if (chatId) {
      const data = await $httpFetch('/api/shopping-agent/v1/chats/:chatId', {
        method: 'GET',
        pathParams: { chatId },
        onResponse,
        onRequest,
      })

      return { data, status: responseStatus }
    }

    const data = await $httpFetch('/api/shopping-agent/v1/chats', {
      method: 'POST',
      body,
      onResponse,
      onRequest,
    })

    return { data, status: responseStatus }
  }

  const sendMessage = async (chatId: string, body: MessageRequestBody) => {
    const data = await $httpFetch(
      '/api/shopping-agent/v1/chats/:chatId/message',
      {
        method: 'POST',
        body,
        pathParams: { chatId },
        onRequest,
      },
    )

    return data
  }

  return { startChat, sendMessage }
}
